import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { api } from "../lib/api";

export const FoundersBanner = () => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/public/founders").then((r) => setF(r.data)); }, []);
  if (!f || f.remaining <= 0) return null;
  const pct = (f.claimed / f.limit) * 100;
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-10 pb-20" data-testid="founders-banner">
      <div className="lux-card p-8 md:p-10 grid md:grid-cols-12 gap-6 items-center border-[#38BDF8]/40">
        <div className="md:col-span-8">
          <p className="eyebrow flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" />The Founding 500</p>
          <h2 className="font-serif-lux text-3xl md:text-4xl mt-3">{f.discount_pct}% off, for good.</h2>
          <p className="text-slate-400 mt-2 text-sm md:text-base">
            The first {f.limit} members lock in {f.discount_pct}% off every line — and get an invite link so friends get it too. The very first member{f.perk_count > 1 ? "s" : ""} get something extra special.
          </p>
          <div className="mt-5 h-2 rounded-full bg-white/5 overflow-hidden max-w-md"><div className="h-full pool-fill rounded-full" style={{ width: `${pct}%` }} /></div>
          <p data-testid="founders-remaining" className="font-mono-lux text-xs text-slate-400 mt-2">{f.remaining} of {f.limit} founding spots left</p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <Link to="/register" data-testid="founders-join-btn" className="btn-gold inline-block px-7 py-3.5">Claim a founding spot</Link>
        </div>
      </div>
    </section>
  );
};
